import { createContext, useContext } from "react";
import type { SupabaseOutletContext } from "./supabase";

export const SupabaseContext = createContext<SupabaseOutletContext | undefined>(
  undefined
);

// Define the shape of your context data
export function useSupabaseContext() {
  const context = useContext(SupabaseContext);
  if (!context) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
}
